import PieveSymbol from '@/components/surfaces/PieveSymbol.jsx';
import AppLogo from '@/components/surfaces/AppLogo.jsx';

/**
 * Pieve and the app as two nodes joined by one line: dashed until a connection works, solid once it
 * does, broken off when the app cannot be connected yet. The line is the page's only drawing.
 */
const ConnectionPath = ({ app, state }) => {
  return (
    <div className="connections-path" data-state={state}>
      <span className="connections-path__node connections-path__node--pieve">
        <PieveSymbol size={28} label="Pieve" />
      </span>
      <svg className="connections-path__line" viewBox="0 0 160 40" preserveAspectRatio="none" aria-hidden="true">
        <path d={state === 'unavailable' ? 'M2 20 C 30 4, 50 4, 66 14' : 'M2 20 C 50 2, 110 38, 158 20'} />
        {state === 'unavailable' && <path d="M94 26 C 110 36, 130 36, 158 20" />}
      </svg>
      <span className="connections-path__node">
        <AppLogo app={app} size="lg" />
      </span>
    </div>
  );
};

export default ConnectionPath;
